import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, Gift } from "lucide-react";

export function RewardPopup({ open, onClose, title, value, subtitle }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="reward-popup"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-6"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-3xl border border-line bg-surface p-10 text-center shadow-2xl"
          >
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 grid h-14 w-14 place-items-center rounded-full bg-brand shadow-lg shadow-brand/40">
              <Gift size={26} className="text-white" />
            </div>
            <div className="label-eyebrow justify-center mt-4">You've unlocked a free upgrade</div>
            <h2 className="font-serif text-4xl text-forest mt-4">{title}</h2>
            <p className="mt-2 text-brand text-lg font-medium">Value ${value.toLocaleString()}</p>
            {subtitle && <p className="mt-3 text-sm text-mutedText">{subtitle}</p>}
            <button
              data-testid="reward-popup-close"
              onClick={onClose}
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-7 py-3 text-white text-sm font-medium hover:bg-brand-dark transition"
            >
              <Sparkles size={15} /> Add to my rewards
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
